/*
 * This file is part of huoxin/filter-rule-manager.
 *
 * Copyright (c) 2026 huoxin.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import FilterEngine from './FilterEngine';
import BuiltinTemplate from './components/BuiltinTemplate';
export const common = {
  FilterEngine,
  BuiltinTemplate
};